import { ThemeInterface } from "../../domain/interface/theme_interface";
import { ThemeRepository } from "../../domain/repository/theme_repository";
import { ThemeApiService } from "../data_source/theme_api_service";

export class ThemeRepositoryImpl implements ThemeRepository {
  private themeApiService: ThemeApiService;

  constructor() {
    this.themeApiService = new ThemeApiService();
  }

  async getThemeByCompanyId(id: string): Promise<ThemeInterface[]> {
    const response = await this.themeApiService.getThemeByCompanyId(id);
    return response.data;
  }

  async getThemeById(id: string): Promise<ThemeInterface> {
    const response = await this.themeApiService.getThemeById(id);
    return response.data;
  }
}
